/* ═══════════════════════════════════════════════════════════════
   Third-party widget embed.

   The iframe already renders and works without this file. Two things
   are layered on top:

     1. Height sync. The vendor posts { type: 'jewlx-resize', height }
        when its content grows. Desktop only — on phones the frame
        fills the viewport and a reported height would fight that.

     2. A cover over the vendor's blank first paint. The resize message
        doubles as the only cross-origin "content is up" signal there
        is, so it clears the cover too, with a timeout behind it so a
        blocked or unauthorised domain never leaves it stuck.

   Both are gated on data-gmd-embed-live, which this script sets. The
   CSS shows the cover only under that attribute, so a script that
   fails to load leaves a plain visible iframe instead of a page
   permanently hidden behind a spinner.

   Messages are checked against the frame's own origin before they are
   trusted. The vendor's snippet does not do this; any other frame or
   opener could otherwise claim to be the widget and drive its height.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var READY_TIMEOUT_MS = 6000;
  var MIN_H = 500;
  var MAX_H = 4000;
  var DESKTOP_MIN_W = 768;

  /** The frame's own origin, or null if the URL is unusable — in which
   *  case no message can be trusted and only the timeout clears it. */
  function originOf(iframe) {
    try {
      return new URL(iframe.src, window.location.href).origin;
    } catch (e) {
      return null;
    }
  }

  function parse(data) {
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    return data && typeof data === 'object' ? data : null;
  }

  function setup(wrap) {
    var iframe = wrap.querySelector('iframe');
    if (!iframe) return;

    var origin = originOf(iframe);
    var settled = false;

    function settle() {
      if (settled) return;
      settled = true;
      wrap.setAttribute('data-gmd-embed-ready', '');
    }

    function onMessage(e) {
      if (!origin || e.origin !== origin) return;
      if (e.source !== iframe.contentWindow) return;

      var payload = parse(e.data);
      if (!payload || payload.type !== 'jewlx-resize') return;

      settle();

      if (typeof payload.height !== 'number') return;
      if (window.innerWidth < DESKTOP_MIN_W) return;

      iframe.style.height = Math.max(MIN_H, Math.min(MAX_H, payload.height)) + 'px';
    }

    window.addEventListener('message', onMessage);

    // A frame that loads but never speaks still deserves to be revealed.
    iframe.addEventListener('load', settle);
    window.setTimeout(settle, READY_TIMEOUT_MS);

    // Set last: everything above is wired before the CSS starts relying on it.
    wrap.setAttribute('data-gmd-embed-live', '');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gmd-embed]').forEach(function (wrap) {
      if (wrap.dataset.gmdEmbedLive !== undefined) return;
      setup(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
